import { BorderRadius, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { colors } from '@shinetools/lumen-tokens/web/colors'

export const PromoCalloutWrapper = styled.div`
  padding: ${Spacing.S8};
  border: 1px solid ${colors.border.highlight.cyan.soft};
  border-radius: ${BorderRadius.R8};
  background-color: ${colors.surface.highlight.cyan.subtle.default};
`
